
<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center">
    <div class="auth-box">
      <div id="loginform">
        <div class="logo">
          <span class="db">
            <img src="@/assets/images/logos/logo-full.png" alt="logo">
          </span>
          <h5 class="font-medium mb-3">Sign In to Admin</h5>
        </div>
        <!-- Form -->
        <div class="row">
          <div class="col-12">
            <form class="form-horizontal mt-3" @submit.prevent="login">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">
                    <i class="fa fa-envelope fa-fw"></i>
                  </span>
                </div>
                <input
                  type="email"
                  class="form-control form-control-lg"
                  placeholder="Email"
                  required
                  v-model="email"
                >
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="fa fa-unlock fa-fw" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  type="password"
                  class="form-control form-control-lg"
                  placeholder="Password"
                  required
                  v-model="password"
                >
              </div>
              <div class="text-danger text-sm" v-if="textError">
                <i class="fa fa-exclamation-triangle fa-fw" aria-hidden="true"></i>
                {{ textError }}
              </div>

              <div class="form-group text-center">
                <div class="col-xs-12 pb-3">
                  <button class="btn btn-block btn-lg btn-info" type="submit">Log In <i class="fa fa-spinner fa-spin" v-if="summiting"></i></button>
                </div>
              </div>

              <div class="form-group mb-0 mt-2">
                <div class="col-sm-12 text-center">Mind The Gap studio</div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <form
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
              @submit.prevent="login"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4 title-page">Ahaslides Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <vs-input
                  name="email"
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                  required
                />

                <vs-input
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                  required
                />

                <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                </div>
                <div class="text-danger text-sm" v-if="textError">{{ textError }}</div>

                <div class="text-center">
                  <vs-button style="width: 100%">
                    Login
                    <i class="feather icon icon-loader" v-if="summiting"></i>
                  </vs-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </vx-card>
    </div>
  </div>-->
</template>



<script>
// @ is an alias to /src
// import Router from "@/router";
import Config from "@/config";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: true,
      textError: "",
      summiting: false
    };
  },
  methods: {
    setLang: function(lang) {
      this.$store.dispatch("setLang", lang);
    },

    login() {
      if (this.summiting) return;
      this.summiting = true;

      this.$http
        .post(Config.api.login, {
          email: this.email,
          password: this.password
        })
        .then(
          res => {
            this.summiting = false;
            this.$store.dispatch("setCurrentUser", res.body);
            this.$cookie.set("ahaTokenAdmin", res.body.token);
            this.$http.headers.common['Authorization'] = 'Bearer ' + res.body.token;
            this.$cookie.set("ahaUserAdmin", res.body.user);
            this.$router.push("/apps/users");
          },
          err => {
            this.summiting = false;
            if (err.body.message) {
              this.textError = err.body.message;
            } else {
              this.textError = err.bodyText;
            }
          }
        );
    },

    registerUser() {
      this.$router.push("/pages/register");
    }
  }
};
</script>

<style lang="scss" scope>
.auth-wrapper {
  background: url("../../assets/images/big/auth-bg.jpg") no-repeat center center;
}
.text-danger {
  margin-bottom: 15px;
}
</style>